/* template */
<template>
<div id="app"><mpx-keep-alive><router-view></router-view></mpx-keep-alive></div></template>
/* styles */
<style mpxStyleOptions='{"mid":"mpx-app-scope"}'>
  html, body, #app {
    height: 100%;
    margin: 0;
    padding: 0;
  }
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "mpx-app-scope"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"mpx-app-scope"}
  /** script content **/
  require("./app.mpx.js?isApp!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./app.mpx?ctorType=app&index=0&isApp&lang=js&mpx&type=script")

  // @ts-ignore
  export default processComponentOption({
    option: global.__mpxOptionsMap["mpx-app-scope"],
    ctorType: "app",
    outputPath: "",
    pageConfig: {},
    componentsMap: {'mpx-keep-alive':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-keep-alive.vue?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true,
    disablePageTransition: true,
  })
</script>